import APP_PACKAGE from "../../package.json"

export const AUTH_URL = import.meta.env.VITE_APP_AUTH_URL;
export const DATACENTRAL_API_URL = import.meta.env.VITE_APP_DATACENTRAL_API_URL;
export const SERVICE_API_URL = import.meta.env.VITE_APP_SERVICE_API_URL;
export const FASTC_URL = import.meta.env.VITE_APP_FASTC_URL;
export const FASTC_API_URL = import.meta.env.VITE_APP_FASTC_API_URL;

export const APP_ENV = import.meta.env.VITE_APP_ENV;
export const SSH_TUNNEL = import.meta.env.VITE_APP_SSH_TUNNEL_URL;

export const SERVICE_SWIFTCACHE_URL = import.meta.env.VITE_APP_SERVICE_SWIFTCACHE_URL;

export const SA = "SA";
export const EXP = "EXP";
export const UUID = "UUID";

export const SERVICES = [
  { value: "CDN", label: "CDN" },
  { value: "VPS", label: "VPS" },
  { value: "HOSTING", label: "HOSTING" },
  { value: "VBM", label: "Bare Metal Server" },
  { value: "TRANSCODING", label: "TRANSCODING" },
  { value: "SECUMAIL", label: "SECUMAIL" },
  { value: "DOMAIN", label: "DOMAIN" },
  { value: "EMAIL", label: "EMAIL" },
  { value: "EMAIL-VPRO", label: "EMAIL VPRO" },
  { value: "COLOCATION", label: "COLOCATION" },
  { value: "WEBSITE", label: "WEBSITE" },
  { value: "STORAGE", label: "STORAGE" },
  { value: "SSL", label: "SSL" },
  { value: "SERVER", label: "SERVER" },
  { value: "Receive Guard", label: "Receive Guard" },
  { value: "LIVESTREAM", label: "LIVESTREAM" },
  { value: "VNIS", label: "VNIS" },
  { value: "EMAIL-EG", label: "Mail Gateway EG-Platform" },
  { value: "LSDN", label: "LSDN" },
  { value: "OTHERS", label: "OTHERS" },
];

import COUNTRIES from "./json/countries.json"
import INDUSTRIES from "./json/industries.json"

export {
  APP_PACKAGE,
  INDUSTRIES,
  COUNTRIES
}